{
  "NAME": "CodeAddModify",
  "GeneralTitle": "Général",
  "ScopeAssignmentTitleTitle": "Attribution du champ d'application",
  "AddUserTitle": "Ajouter un code",
  "ModifyCodeTitle": "Modifier le code",
  "GUID": "(GUID) :",
  "GUIDPlaceholder": "[Généré automatiquement]",
  "Code": "Code :",
  "CodeType": "Type de code :",
  "CodeTypeHelp": "Détermine le type du nouveau code",
  "CodeTypeOptionOne": "Compte\/autorisation",
  "CodeTypeOptionTwo": "ACD non disponible",
  "CodeTypePlaceholder": "Compte\/autorisation",
  "Description": "Description :",
  "UpdateExisting": "Mettre à jour les éléments en double :",
  "TelServer": "Serveur de téléphonie",
  "Partition": "Partition",
  "CodeAddModify_AccountAuthorisation": "Compte\/autorisation",
  "CodeAddModify_ACDNotAvailable": "ACD non disponible",
  "CodeAddModify_ErrorMessage_Server_Error": "Erreur du serveur",
  "CodeAddModify_ErrorMessage_Successful": "Succès",
  "CodeAddModify_ServerErrorTitle": "Erreurs de validation",
  "CodeAddModify_ValidationWarning": "Veillez à ce que tous les champs soient correctement remplis",
  "CodeAddModify_ButtonHelpLabel": "Aide ?",
  "CodeAddModify_ButtonSubmitLabel": "Économiser",
  "CodeAddModify_ButtonCancelLabel": "Annuler",
  "CodeAddModify_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues à la fermeture.",
  "CodeAddModify_PromptConfirm": "Oui",
  "CodeAddModify_PromptCancel": "Annuler",
  "CodeAddModify_DetailsTitle": "Détails de l'utilisateur",
  "CodeAddModify_ValidationError": "Erreur de validation",
  "Errors_Code_Required": "Ce champ est obligatoire",
  "Errors_Code_Validation": "Format valide requis : 1, 3-5",
  "Errors_CodeAddModify_Code_Length": "Le nom du code doit comporter moins de 100 caractères",
  "Errors_CodeAddModify_Description_Length": "La description doit être inférieure à 100 caractères"
}